import { useSelector } from "react-redux";
import { Measurements, selectMeasurementType } from "../../../store/slices/settingsSlice";

function ConvertUnit({ Metric, Imperial }) {
  const measurementType = useSelector(selectMeasurementType);

  if (measurementType === Measurements.METRIC) {
    return Metric;
  }

  if (measurementType === Measurements.IMPERIAL) {
    return Imperial;
  }
}

export default ConvertUnit;
